/* AUTEUR PDP - Engineering map.
   Draws the actives-to-concerns wiring and traces it on selection.
   No dependencies. Content is readable and operable if this never runs. */
(function () {
  var REDUCE = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var EASE = 'cubic-bezier(.16,1,.3,1)';
  var NS = 'http://www.w3.org/2000/svg';

  function init(root) {
    var stage = root.querySelector('[data-eng-stage]');
    var svg = root.querySelector('[data-eng-wires]');
    var hub = root.querySelector('[data-eng-hub]');
    var countEl = root.querySelector('[data-eng-count]');
    var statusEl = root.querySelector('[data-eng-status]');
    if (!stage || !svg) return;

    var actives = [].slice.call(root.querySelectorAll('[data-eng-active]'));
    var concerns = [].slice.call(root.querySelectorAll('[data-eng-concern]'));
    if (!actives.length || !concerns.length) return;

    var concernName = {};
    concerns.forEach(function (c) {
      var n = c.querySelector('.apdp-eng__name');
      concernName[c.getAttribute('data-eng-concern')] = n ? n.textContent : '';
    });

    var links = [];
    actives.forEach(function (a) {
      var keys = (a.getAttribute('data-eng-treats') || '').split(',').map(function (s) { return s.trim().toLowerCase(); }).filter(Boolean);
      keys.forEach(function (k) {
        var c = concerns.filter(function (x) { return x.getAttribute('data-eng-concern').toLowerCase() === k; })[0];
        if (c) links.push({ a: a, c: c, akey: a.getAttribute('data-eng-active'), ckey: k, path: null, len: 0 });
      });
    });
    if (!links.length) return;

    actives.forEach(function (a) {
      var mine = links.filter(function (l) { return l.a === a; });
      if (!mine.length) return;
      var wrap = document.createElement('span');
      wrap.className = 'apdp-eng__chips';
      mine.forEach(function (l) {
        var chip = document.createElement('span');
        chip.className = 'apdp-eng__chip';
        chip.textContent = concernName[l.ckey] || l.ckey;
        wrap.appendChild(chip);
      });
      a.appendChild(wrap);
    });

    links.forEach(function (l) {
      l.path = document.createElementNS(NS, 'path');
      l.path.setAttribute('class', 'apdp-eng__wire');
      svg.appendChild(l.path);
    });

    var baseCount = parseInt(countEl && countEl.textContent, 10) || actives.length;
    var drawn = false;

    function anchor(node, side) {
      var port = node.querySelector('[data-eng-port]');
      var r = (port || node).getBoundingClientRect();
      var s = stage.getBoundingClientRect();
      return { x: (side === 'right' ? r.right : r.left) - s.left, y: r.top - s.top + r.height / 2 };
    }

    function layout() {
      var s = stage.getBoundingClientRect();
      if (!s.width) return;
      svg.setAttribute('viewBox', '0 0 ' + s.width + ' ' + s.height);
      var h = hub.getBoundingClientRect();
      var hx = h.left - s.left + h.width / 2;
      var hy = h.top - s.top + h.height / 2;
      links.forEach(function (l) {
        var p1 = anchor(l.a, 'right');
        var p2 = anchor(l.c, 'left');
        var k1 = Math.max(40, Math.min((hx - p1.x) * 0.55, 200));
        var k2 = Math.max(40, Math.min((p2.x - hx) * 0.55, 200));
        var d = 'M' + p1.x + ',' + p1.y +
                'C' + (p1.x + k1) + ',' + p1.y + ' ' + (hx - k1) + ',' + hy + ' ' + hx + ',' + hy +
                'C' + (hx + k2) + ',' + hy + ' ' + (p2.x - k2) + ',' + p2.y + ' ' + p2.x + ',' + p2.y;
        l.path.setAttribute('d', d);
        l.len = l.path.getTotalLength();
        l.path.style.strokeDasharray = l.len;
        l.path.style.strokeDashoffset = (drawn || REDUCE) ? 0 : l.len;
      });
    }

    function trace(l, delay) {
      if (REDUCE) { l.path.style.strokeDashoffset = 0; return; }
      l.path.style.strokeDashoffset = 0;
      l.path.animate([{ strokeDashoffset: l.len }, { strokeDashoffset: 0 }], { duration: 620, delay: delay || 0, easing: EASE, fill: 'both' });
    }

    /* The hub numeral is a readout, so its final value is asserted rather than
       left to the last animation frame. Background tabs throttle rAF and would
       otherwise strand it on a wrong number. */
    var counting = null, settle = null;
    function setCount(target) {
      if (!countEl) return;
      if (counting) cancelAnimationFrame(counting);
      if (settle) clearTimeout(settle);
      var from = parseInt(countEl.textContent, 10);
      if (isNaN(from)) from = target;
      if (from === target) { countEl.textContent = target; return; }
      if (REDUCE || document.hidden) { countEl.textContent = target; return; }
      var t0 = null, dur = 420;
      function step(ts) {
        if (!t0) t0 = ts;
        var p = Math.min((ts - t0) / dur, 1);
        countEl.textContent = Math.round(from + (target - from) * (1 - Math.pow(1 - p, 3)));
        if (p < 1) { counting = requestAnimationFrame(step); }
        else { counting = null; countEl.textContent = target; }
      }
      counting = requestAnimationFrame(step);
      settle = setTimeout(function () {
        if (counting) { cancelAnimationFrame(counting); counting = null; }
        countEl.textContent = target;
      }, dur + 120);
    }

    var lockedA = null, lockedC = null, hoverKey = null, hoverType = null;

    function apply() {
      var aKey = hoverType === 'a' ? hoverKey : lockedA;
      var cKey = hoverType === 'c' ? hoverKey : lockedC;
      var live = [];
      links.forEach(function (l) {
        var on = (aKey && l.akey === aKey) || (cKey && l.ckey === cKey);
        var any = !!(aKey || cKey);
        l.path.classList.toggle('is-lit', !!on);
        l.path.classList.toggle('is-dim', any && !on);
        if (on) live.push(l);
      });
      actives.forEach(function (a) {
        var k = a.getAttribute('data-eng-active');
        var on = live.some(function (l) { return l.a === a; });
        a.classList.toggle('is-lit', on);
        a.classList.toggle('is-off', !!(aKey || cKey) && !on);
        a.setAttribute('aria-pressed', String(k === lockedA));
      });
      concerns.forEach(function (c) {
        var k = c.getAttribute('data-eng-concern');
        var on = live.some(function (l) { return l.c === c; });
        c.classList.toggle('is-lit', on);
        c.classList.toggle('is-off', !!(aKey || cKey) && !on);
        c.setAttribute('aria-pressed', String(k === lockedC));
      });
      hub.classList.toggle('is-live', !!(aKey || cKey));
      setCount((aKey || cKey) ? live.length : baseCount);
      if (statusEl) {
        if (aKey) {
          var an = root.querySelector('[data-eng-active="' + aKey + '"] .apdp-eng__name');
          statusEl.textContent = (an ? an.textContent : aKey) + ' treats ' + live.map(function (l) { return concernName[l.ckey]; }).join(', ') + '.';
        } else if (cKey) {
          statusEl.textContent = (concernName[cKey] || cKey) + ' is addressed by ' + live.length + (live.length === 1 ? ' active.' : ' actives.');
        } else {
          statusEl.textContent = '';
        }
      }
      return live;
    }

    function activate(type, key, sticky) {
      if (sticky) {
        if (type === 'a') { lockedA = lockedA === key ? null : key; lockedC = null; }
        else { lockedC = lockedC === key ? null : key; lockedA = null; }
      }
      var live = apply();
      if (live.length && drawn) live.forEach(function (l, i) { trace(l, i * 55); });
    }

    function bind(nodes, type, attr) {
      nodes.forEach(function (n) {
        var key = n.getAttribute(attr);
        n.addEventListener('click', function () { activate(type, key, true); });
        n.addEventListener('mouseenter', function () { hoverKey = key; hoverType = type; activate(type, key, false); });
        n.addEventListener('mouseleave', function () { hoverKey = null; hoverType = null; apply(); });
        n.addEventListener('focus', function () { hoverKey = key; hoverType = type; activate(type, key, false); });
        n.addEventListener('blur', function () { hoverKey = null; hoverType = null; apply(); });
      });
    }
    bind(actives, 'a', 'data-eng-active');
    bind(concerns, 'c', 'data-eng-concern');

    layout();
    if (window.ResizeObserver) {
      var rt;
      new ResizeObserver(function () { clearTimeout(rt); rt = setTimeout(layout, 120); }).observe(stage);
    } else {
      window.addEventListener('resize', function () { setTimeout(layout, 150); });
    }

    function revealAll() {
      if (drawn) return;
      drawn = true;
      if (REDUCE) { links.forEach(function (l) { l.path.style.strokeDashoffset = 0; }); return; }
      links.forEach(function (l, i) { trace(l, 90 + i * 70); });
    }
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (es) {
        es.forEach(function (e) { if (e.isIntersecting) { revealAll(); io.disconnect(); } });
      }, { threshold: 0.18 });
      io.observe(stage);
      setTimeout(revealAll, 4000);
    } else {
      revealAll();
    }
  }

  function boot() {
    [].slice.call(document.querySelectorAll('[data-apdp-eng]')).forEach(init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
